import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import { StatTile } from '../../components/StatTile';

/** "Active Shipments: currently ongoing", as it appears on the customer and agent pages */
export const ActiveShipmentsTile = ({ count, onClick }: { count: number; onClick: () => void }) => (
  <StatTile
    count={count}
    title="Active Shipments"
    note="Currently ongoing"
    icon={<LocalShippingOutlined />}
    tone="info"
    onClick={onClick}
  />
);
